module.exports = __webpack_public_path__ + "static/media/id4x4.03e807c5.jpg";